// A tiny history router: paths like /ture/:id, links that do not reload the page.
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const listeners = new Set();
const notify = () => listeners.forEach((f) => f());
window.addEventListener('popstate', notify);

export function navigate(href, { replace = false } = {}) {
  history[replace ? 'replaceState' : 'pushState'](null, '', href);
  if (!replace) window.scrollTo(0, 0);
  notify();
}

export function useRoute() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const f = () => setTick((n) => n + 1);
    listeners.add(f);
    return () => listeners.delete(f);
  }, []);
  return { path: location.pathname, query: new URLSearchParams(location.search) };
}

export function Link({ href, onClick, ...props }) {
  const click = (e) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || props.target) return;
    e.preventDefault();
    navigate(href);
  };
  return h('a', { href, onClick: click, ...props });
}

const parts = (p) => p.split('/').filter(Boolean);

export function match(pattern, path) {
  const want = parts(pattern);
  const got = parts(path);
  if (want.length !== got.length) return null;
  const params = {};
  for (let i = 0; i < want.length; i++) {
    if (want[i].startsWith(':')) {
      try {
        params[want[i].slice(1)] = decodeURIComponent(got[i]);
      } catch {
        return null;
      }
    } else if (want[i] !== got[i]) {
      return null;
    }
  }
  return params;
}
